module.exports = __webpack_public_path__ + "img/chevron-down-red.19931f49.svg";